import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import logoSm from "../../assets/images/logo-sm.png";
// import avatar1 from "../../assets/images/users/avatar-1.jpg";
import ChangePassword from "../../modules/Authentication/ChangePassword";
import { RootState } from "../../store";

// Selector to extract user & error from Login slice
const selectLoginState = (state: RootState) => state.Login;

const selectUserData = createSelector(selectLoginState, (login) => ({
  username: login.username,
  phone_no: login.phone_no,
  email_id: login.email_id,
  error: login.error,
}));

const ProfileDropdown: React.FC = () => {
  const { username, phone_no, email_id } = useSelector(selectUserData);

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [userName, setUserName] = useState("User");

  useEffect(() => {
    if (userName) {
      setUserName(capitalize(username));
      console.log("in if");
    } else {
      setUserName("User");
      console.log("outside");
    }
  }, [username]);

  const toggleProfileDropdown = () => {
    setIsProfileDropdown((prev) => !prev);
  };

  const handleChangePwdClick = () => {
    setShowChangePasswordModal((prev) => !prev);
  };

  const initials = username ? username: "N/A";


  const capitalize = (str: string = "") =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  let avatar1 = logoSm;

  return (
    <>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <div className="avatar-sm img-thumbnail rounded-circle flex-shrink-0">
              {avatar1 ? (
                <img
                  src={avatar1}
                  alt="avatar"
                  className="img-fluid d-block rounded-circle"
                />
              ) : (
                <div className="avatar-title text-uppercase border rounded-circle bg-light text-primary d-flex align-items-center justify-content-center">
                  {initials}
                </div>
              )}
            </div>
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userName}
              </span>
            </span>
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {userName}!</h6>

          {/* <DropdownItem tag={Link} to="/profile">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </DropdownItem> */}

          <DropdownItem onClick={handleChangePwdClick}>
            <i className="mdi mdi-lock-reset text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Change Password</span>
          </DropdownItem>

          {/* <DropdownItem tag={Link} to="/pages-profile-settings">
            <span className="badge bg-success-subtle text-success mt-1 float-end">
              New
            </span>
            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Settings</span>
          </DropdownItem>

          <DropdownItem tag={Link} to="/auth-lockscreen-basic">
            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Lock screen</span>
          </DropdownItem> */}

          <DropdownItem tag={Link} to="/logout">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Logout</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <ChangePassword
        show={showChangePasswordModal}
        onCloseClick={handleChangePwdClick}
      />
    </>
  );
};

export default ProfileDropdown;
